<template>
  <div class="multi-select">
    <div class="empty-state" v-show="selectedItems.length <= 0">
      {{ emptyStateMessage }}
    </div>
    <div class="items" v-show="selectedItems.length > 0">
      <div
        class="item"
        :key="`selectedItem_${i}`"
        v-for="(item, i) in selectedItems"
      >
        <div class="label-sublabel">
          {{ item.label }}
          <span
            class="ml-2 sub-label text-sm text-mid-gray"
            v-if="item.subLabel"
          >
            {{ item.subLabel }}
          </span>
        </div>
        <span v-if="isQty">
          <Number name="Quantity" v-model="item.qty" required />
        </span>
        <a class="icon-container" @click="deselectItem(i)">
          <i class="bdg-icon trash fa-fw text-lg text-red" />
        </a>
      </div>
    </div>

    <dropdown
      ref="dropdown"
      class="mt-2"
      :options="searchResults"
      :search-text="searchText"
      :placeholder="beginTypingMessage"
      @search-input="searchText = $event"
      @add="addNew"
      v-model="selectedSearchResult"
      searchable
      :can-add="canAdd"
    />
  </div>
</template>

<script>
import Dropdown from "./Dropdown";
import Number from "./BdgNumberField";

export default {
  name: "MultiSelect",
  components: { Dropdown, Number },
  props: {
    emptyStateMessage: {
      type: String,
      default: "Nothing Selected"
    },
    beginTypingMessage: {
      type: String,
      default: "Begin typing..."
    },
    searchFunction: {
      type: Function,
      default: null
    },
    value: {
      type: Array,
      default: () => []
    },
    canAdd: Boolean,
    isQty: Boolean
  },
  data() {
    return {
      isMounted: false,
      items: [],
      searchText: "",
      selectedSearchResult: null
    };
  },
  computed: {
    selectedItems: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    searchResults() {
      if (this.searchFunction) {
        return this.searchFunction(this.searchText);
      }

      return [];
    }
  },
  watch: {
    selectedSearchResult(newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.selectItem(newVal);
        this.selectedSearchResult = null;
      }
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    selectItem(item) {
      this.selectedItems.push(item);
      this.searchText = "";
    },
    deselectItem(index) {
      this.selectedItems.splice(index, 1);
    },
    addNew() {
      this.$emit("add-new", this.searchText);
      this.searchText = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.multi-select {
  .empty-state {
    @apply flex justify-center items-center border border-dashed border-red mb-2 p-3 text-placeholder-gray;
  }

  .items {
    .item {
      @apply flex justify-between items-center w-full border border-lightgray px-4 py-3 bg-white leading-normal cursor-default;

      &:not(:first-child) {
        @apply border-t-0;
      }
    }
  }
}
</style>
